<template>
  <editor api-key="zaw1vim746a6hngmrlxlworj9cswkanxln3b2abe4xheyfw5" :init="editorInit" :placeholder="phVal" v-model="content" />
</template>

<script>
import { UPloadFileApi, GetKey_Url } from "@/api/student";
import Editor from "@tinymce/tinymce-vue";

export default {
  components: {
    editor: Editor,
  },
  props: {
    /* 编辑器的内容 */
    value: {
      type: String,
      default: "",
    },
    /* 高度 */
    height: {
      type: Number,
      default: null,
    },
    /* 最小高度 */
    minHeight: {
      type: Number,
      default: null,
    },
    phVal: {
      type: String,
      default: "请输入",
    },
  },
  data() {
    return {
      //富文本初始化
      editorInit: {
        height: this.height ? this.height : this.minHeight, //配置富文本高度
        menubar: false,
        plugins: [
          // "a11ychecker",
          "advlist",
          // "advcode",
          // "advtable",
          "autolink",
          // "checklist",
          // "export",
          "lists",
          "link",
          "image",
          "charmap",
          "preview",
          "anchor",
          "searchreplace",
          "visualblocks",
          // "powerpaste",
          "fullscreen",
          // "formatpainter",
          "insertdatetime",
          "media",
          "table",
          "wordcount",
        ],
        toolbar:
          "undo redo | casechange blocks | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlst checklist outdent indent | removeformat | a11ycheck code table | image",
        language_url: "./tinymce/langs/zh-Hans.js", //指定中文包
        language: "zh-Hans", //中文

        images_upload_handler: this.imagesUploadHandler,
      },
      content: "", //富文本内容
      dcUploadConfig: {}, //德诚上传配置
    };
  },
  created() {
    this.getDcUploadConfig();
  },
  mounted() {},
  methods: {
    //获取德诚上传配置
    getDcUploadConfig() {
      GetKey_Url().then((res) => {
        this.dcUploadConfig = res.data;
      });
    },
    //图片上传回调
    imagesUploadHandler(blobInfo, succFun, failFun) {
      const idName = "tinymce-upload-images";
      document
        .getElementsByClassName("tox-dropzone")[0]
        .children[1].children[0].setAttribute("id", idName);

      let dcuploadObj = dcupload({
        id: idName,
        key: this.dcUploadConfig.key,
        notify_url: this.dcUploadConfig.notify_url,
      });

      setTimeout(() => {
        //开始上传
        dcuploadObj.start(
          {
            // 自定义参数
            data: {},
            // 上传进度
            on_progress(index, count) {},
          },
          (err, results) => {
            //上传完成返回
            if (err) {
              if (err.msg != "stop") {
                console.error(err);
                failFun(err.msg);
              } else {
                console.log(err);
              }
            } else {
              //转账凭证上传成功回调
              let etag = results.upload.CompleteMultipartUploadResult.ETag;
              //去掉字符串的双引号
              etag = etag.replace(/"/g, "");
              UPloadFileApi({ etag }).then((res) => {
                succFun(res.data.savepath);
              });
            }
          }
        );
      }, 1000);
    },
  },
  watch: {
    //监听value
    value: {
      handler(val) {
        if (val !== this.content) {
          this.content = val === null ? "" : val;
        }
      },
      immediate: true,
    },
    //监听富文本内容
    content(val) {
      this.$emit("input", val);
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="less">
.tox-notifications-container {
  display: none;
}
</style>
